import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sortField", "sortDirection", "sortHint", "refreshColumns"]
  static values = { sorts: Object }

  connect() {
    this.syncSort()
  }

  changeSort() {
    this.sortDirectionTarget.value = this.sortsValue[this.sortFieldTarget.value].default
    this.syncSort()
  }

  syncSort() {
    const settings = this.sortsValue[this.sortFieldTarget.value]
    for (const option of this.sortDirectionTarget.options) {
      option.textContent = settings.directions[option.value]
    }
    const hint = settings.hints[this.sortDirectionTarget.value]
    this.sortHintTarget.textContent = hint
    this.sortHintTarget.hidden = !hint
  }

  refreshColumns(event) {
    event.target.form.requestSubmit(this.refreshColumnsTarget)
  }
}
